﻿import { loadGoogleMaps } from "googlemaps/loadGoogleMaps";
import { autocomplete } from "googlemaps/autocomplete";
window.autocomplete = autocomplete;
window.loadGoogleMaps = loadGoogleMaps;
